export default __webpack_public_path__ + "static/media/logo-upn.f5a4ea6d.png";